import React, { forwardRef } from 'react';
import * as PropTypes from 'prop-types';

import { Box, Button, Flex, SpinnerIcon } from '../..';
import { SxProp } from '../../internal/styles/sx';
import { ButtonProps } from '../Button/types';

const noop = (): void => {
  /* */
};

const spinnerSize = {
  small: 'small',
  medium: 'base',
  large: 'medium',
} as const;

export interface ButtonWithLoadingProps extends ButtonProps, SxProp {
  loading?: boolean;
}

const ButtonWithLoading = forwardRef<
  HTMLButtonElement,
  Omit<ButtonWithLoadingProps, 'ref'>
>(
  (
    { sx, children, loading = false, size = 'medium', onClick, ...rest },
    ref
  ) => {
    return (
      <Button
        onClick={!loading ? onClick : noop}
        size={size}
        {...rest}
        sx={{
          ...sx,
          position: 'relative',
        }}
        ref={ref}
      >
        {loading && (
          <Flex
            position="absolute"
            width="100%"
            height="100%"
            justifyContent="center"
            alignItems="center"
            sx={{ top: '0', left: '0' }}
          >
            <SpinnerIcon size={spinnerSize[size]} />
          </Flex>
        )}

        <Box
          sx={{
            opacity: loading ? 0 : 1,
          }}
        >
          {children}
        </Box>
      </Button>
    );
  }
);

ButtonWithLoading.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'text',
    'positive',
    'warning',
    'critical',
  ]),
  nativeType: PropTypes.oneOf(['submit', 'reset', 'button']),
  /**
   * show Loading spinner
   */
  loading: PropTypes.bool,
  sx: PropTypes.object,
};

export default ButtonWithLoading;
